import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { Subject } from 'rxjs/Subject';
import 'rxjs/add/operator/map';
import 'rxjs/add/observable/forkJoin';

import { environment } from '../../../environments/environment';

@Injectable()
export class OutorgarProcuracaoService {
  private data = new Subject<any>();
  data$ = this.data.asObservable();

  public outorgarData: any;

  url: string = environment.BASE_URL;

  constructor(private http: HttpClient) {}

  getData(): Observable<any> {
    const sistemas = this.http
      .get(`${this.url}/aplicacoes/funcionalidadesAutorizadasProcuracao`)
      .map(res => res);
    const tiposProcuracao = this.http
      .get(`${this.url}/tiposProcuracao/ativos`)
      .map(res => res);
    return Observable.forkJoin([sistemas, tiposProcuracao]);
  }
  getFuncionalidadeAutorizadasProcuracao(codigoTipoProcuracao): Observable<any> {
    const params = new HttpParams().set('codigoTipoProcuracao', codigoTipoProcuracao);
    return this.http
      .get(`${this.url}/aplicacoes/funcionalidadesAutorizadasProcuracao`, { params: params })
      .map(data => {
        return data;
      });
  }

  buscarProcurador(cpfCnpj): Observable<any> {
    const params = new HttpParams().set('cpfCnpj', cpfCnpj);
    return this.http
      .get(`${this.url}/usuarios/procuradores/ativos`, { params: params })
      .map(data => {
        return data;
      });
  }

  salvarUsuarioProcuracao(data): Observable<any> {
    const usuario = data;

    const formData = new FormData();
    formData.append('cpfCnpj', usuario.cpfCnpj);
    formData.append('nomeRazaoSocial', usuario.nomeRazaoSocial);
    formData.append('email', usuario.email);
    formData.append('ddd', usuario.ddd);
    formData.append('celular', usuario.celular);

    return this.http
      .post(`${this.url}/usuarios/procurador`, formData)
      .map(data => {
        let body = data;
        return body;
      });
  }

  setData(data) {
    this.data.next(data);
  }

  gerarDocumento(data): Observable<any> {
    const outorga = data;
    console.log('outorga ', outorga);
    return this.http
      .post(`${this.url}/procuracoes/gerarDocumento`, outorga, {
        headers: new HttpHeaders().set('Content-Type', 'multipart/form-data')
      })
      .map(data => {
        console.log('data ', data);
        return data;
      });
  }

  gerarDocumentoRevogacao(
    certificado: string,
    codigoProcuracao: any
  ): Observable<any> {
    const formData = new FormData();
    formData.append('certificado', certificado);
    return this.http
      .post(
        `${this.url}/procuracoes/${codigoProcuracao}/gerarDocumentoRevogacao`,
        formData,
        {
          headers: new HttpHeaders().set('Content-Type', 'multipart/form-data')
        }
      )
      .map(data => {
        console.log('data ', data);
        return data;
      });
  }

  outorgarProcuracao(data): Observable<any> {
    const outorgaProcuracao = data;
    return this.http
      .post(`${this.url}/procuracoes`, outorgaProcuracao, {
        headers: new HttpHeaders().set('Content-Type', 'multipart/form-data')
      })
      .map(data => {
        return data;
      });
  }
}
